import React from "react";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import Reveal from "./Reveal";
import { contact } from "../mock";

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer id="contact" className="bg-neg-green-dark text-neg-cream">
      {/* Leasing banner */}
      <div className="border-y border-neg-gold/20 py-14">
        <div className="mx-auto max-w-5xl px-6 lg:px-10 text-center">
          <Reveal>
            <p className="font-display text-neg-gold text-2xl sm:text-3xl italic">
              {contact.banner}
            </p>
            <p className="mt-5 text-neg-cream/70 max-w-xl mx-auto leading-relaxed">
              {contact.intro}
            </p>
            <p className="mt-6 text-lg tracking-wide text-neg-cream font-medium">{contact.team}</p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
              <a
                href={contact.phoneHref}
                className="inline-flex items-center gap-2 text-neg-cream/85 hover:text-neg-gold transition-colors"
              >
                <Phone size={17} className="text-neg-gold" /> {contact.phone}
              </a>
              <a
                href={contact.emailHref}
                className="inline-flex items-center gap-2 text-neg-cream/85 hover:text-neg-gold transition-colors"
              >
                <Mail size={17} className="text-neg-gold" /> {contact.email}
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Bottom */}
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-12">
        <div className="grid sm:grid-cols-2 gap-8 items-center">
          <div>
            <div className="font-display text-neg-gold text-2xl italic">North East Grove</div>
            <div className="mt-4 flex items-start gap-2 text-neg-cream/70">
              <MapPin size={17} className="text-neg-gold shrink-0 mt-1" />
              <p>{contact.address.join(" ")}</p>
            </div>
          </div>
          <div className="sm:text-right">
            <button
              onClick={scrollTop}
              className="inline-flex items-center gap-2 border border-neg-gold/40 text-neg-gold px-5 py-3 text-xs tracking-widest uppercase hover:bg-neg-gold hover:text-neg-green-dark transition-all duration-300"
            >
              Back to top <ArrowUp size={14} />
            </button>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-neg-gold/15 text-center text-neg-cream/50 text-sm">
          {contact.copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
